(( $ ) => {
    'use strict';

    if (!$.apusThemeExtensions) {
        $.apusThemeExtensions = {};
    }

    class ApusThemeCore {
        constructor() {
            // this.init();
        }
        /**
         *  Initialize
         */
        init() {
            AOS.init();
            
            // slick init
            this.initSlick($(".slick-carousel"));
            
            // back to top
            this.backToTop();

            // popup image
            this.popupImage();

            $('[data-bs-toggle="tooltip"]').tooltip();

            this.collectionView();
            this.swatchCard();
            
            // quickview
            this.quickView();
            this.quickViewAddCart();
            this.quickViewSelectVariants();

            // Cart
            this.addToCart();
            this.miniCart();
            this.cartChangeQty();

            // freeShipping
            var self = this;
            Shopify.getCart(function(cart){
                self.freeShipping(cart);
            });

            // Product Detail
            this.productDetails();

            // compare
            this.processCompare();
            // wishlist
            this.processWishlist();

            // product Recommendations
            this.productRecommendations();

            this.searchHeader();

            this.initMobileMenu();

            this.loginRegister();

            this.headerCart();
            
            this.cookieSection();

            $(document.body).on('click', '.nav [data-toggle="dropdown"]' ,function(){
                if ( this.href && this.href != '#'){
                    if ( this.target && this.target == '_blank' ) {
                        window.open(this.href, '_blank');
                    } else {
                        window.location.href = this.href;
                    }
                }
            });

            // share
            $('.js-share-button').on('click', function (e) {
                e.stopPropagation();
                $(this).parent().toggleClass('active');
            });
            $('body').on('click', function() {
                if ($('.js-share-button-wrapper').hasClass('active')) {
                    $('.js-share-button-wrapper').removeClass('active');
                }
            });
            $('.js-share-button-wrapper').on('click', function(e) {
                e.stopPropagation();
            });
            this.loadExtensions();
        }
        /**
         *  Extensions: Load scripts
         */
        loadExtensions() {
            
            Object.values($.apusThemeExtensions).forEach(fn => {
                if (typeof fn === 'function') {
                    fn.call(this);
                }
            });
        }

        attributeToString(attribute) {
            if (typeof attribute !== 'string') {
                attribute += '';
                if (attribute === 'undefined') {
                    attribute = '';
                }
            }
            return jQuery.trim(attribute);
        }

        headerCart() {
            var self = this;

            $('.action-addon, .btn-close-addon').on('click', function () {
                $(this).closest('.block-addon__box').find('.block-addon__content--wrap').toggleClass('action');
            });

            // cart note
            $('.cart-notes-submit').on( "click", function() {
                var noteText = $('#cart__note').val();
                var noteText_string = self.attributeToString(noteText);
                $.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    data: 'note=' + noteText_string
                });

                $(this).closest('.js-note-cart').removeClass('action');
            });

            // check out button
            $('checkout-button').each(function () {

                var $el = $(this);
                var $checkbox = $el.find('.checkbox__input');
                var $button = $el.find('a[name="checkout"]');

                function updateState() {
                    if ($checkbox.is(':checked')) {
                        $button.removeClass('disabled');
                    } else {
                        $button.addClass('disabled');
                    }
                }

                // init
                updateState();

                // listen change
                $checkbox.on('change', updateState);

                $button.on('click', function (e) {
                    if ($(this).hasClass('disabled')) {
                        e.preventDefault();
                    }
                });

            });

            // add gift cart
            $(document).on('click', '.add-gift__btn', function(e){
                e.preventDefault();
                var $this = $(this);
                $this.addClass('loading');

                var idGift = $this.data('id');

                Shopify.addItem(idGift, 1, function(item){
                    //console.log(item);
                    self.generateCart();
                    self.updateElements();
                    setTimeout(function() {
                        $this.removeClass('loading');
                    },300);
                    if(theme_opts.cartpage){
                        location.reload();
                        $("html, body").animate({ scrollTop: 0 }, "normal");
                    }
                });
              
            })
        }

        checkGift(cart){
            var idGift = $('.add-gift__btn').data('id');
            
            var cartHasGift = false;
            var itemCount = cart.items.length;
            for (let i = 0; i < itemCount; i++) {
                var product = cart.items[i];
                var product_id = product.id;

                if(product_id === idGift) {
                    cartHasGift = true
                    
                    break;
                }
            }
            if ( cartHasGift ) {
                $('.giftwrap').addClass('hide');
                $('.boxgift').removeClass('action');
                $('.add-gift__btn').removeClass('loading');
            } else {
                $('.giftwrap').removeClass('hide');
                $('.boxgift').removeClass('action');
                $('.add-gift__btn').removeClass('loading');
            }
        }

        loginRegister() {
            $('#RecoverPassword, #HideRecoverPasswordLink').on('click', function () {
                $('#CustomerLoginForm, #RecoverPasswordForm').toggleClass('hide');
            });
        }

        initSlick(element) {
            var self = this;
            if( $(this).hasClass('arrow-large') ){
                var icon_arrow_left = "<svg width='80' height='22' viewBox='0 0 80 22' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M12.9766 6.93936e-06C13.1349 6.9532e-06 13.2933 0.0583394 13.4183 0.183339C13.6599 0.425006 13.6599 0.825006 13.4183 1.06667L3.80159 10.6833L13.4183 20.3C13.6599 20.5417 13.6599 20.9417 13.4183 21.1833C13.1766 21.425 12.7766 21.425 12.5349 21.1833L2.47659 11.125C2.23493 10.8833 2.23493 10.4833 2.47659 10.2417L12.5349 0.183339C12.6599 0.0583394 12.8183 6.92552e-06 12.9766 6.93936e-06Z' fill='currentColor'/><path d='M3.06094 10.0589L79.3749 10.0589C79.7166 10.0589 79.9999 10.3423 79.9999 10.6839C79.9999 11.0256 79.7166 11.3089 79.3749 11.3089L3.06094 11.3089C2.71927 11.3089 2.43594 11.0256 2.43594 10.6839C2.43594 10.3423 2.71927 10.0589 3.06094 10.0589Z' fill='currentColor'/></svg>";
                var icon_arrow_right = "<svg width='80' height='22' viewBox='0 0 80 22' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M67.0233 6.93936e-06C66.865 6.9532e-06 66.7066 0.0583394 66.5816 0.183339C66.34 0.425006 66.34 0.825006 66.5816 1.06667L76.1983 10.6833L66.5816 20.3C66.34 20.5417 66.34 20.9417 66.5816 21.1833C66.8233 21.425 67.2233 21.425 67.465 21.1833L77.5233 11.125C77.765 10.8833 77.765 10.4833 77.5233 10.2417L67.465 0.183339C67.34 0.0583394 67.1816 6.92552e-06 67.0233 6.93936e-06Z' fill='currentColor'/><path d='M76.939 10.0589L0.625002 10.0589C0.283335 10.0589 1.83788e-06 10.3423 1.86775e-06 10.6839C1.89762e-06 11.0256 0.283335 11.3089 0.625002 11.3089L76.939 11.3089C77.2806 11.3089 77.564 11.0256 77.564 10.6839C77.564 10.3423 77.2806 10.0589 76.939 10.0589Z' fill='currentColor'/></svg>";
            } else {
                var icon_arrow_left = "<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M7.97669 4.31608C8.13503 4.31608 8.29336 4.37442 8.41836 4.49942C8.66003 4.74108 8.66003 5.14108 8.41836 5.38275L3.80169 9.99941L8.41836 14.6161C8.66003 14.8577 8.66003 15.2577 8.41836 15.4994C8.17669 15.7411 7.77669 15.7411 7.53503 15.4994L2.47669 10.4411C2.23503 10.1994 2.23503 9.79941 2.47669 9.55775L7.53503 4.49942C7.66003 4.37442 7.81836 4.31608 7.97669 4.31608Z' fill='currentColor'/><path d='M3.06094 9.375L17.0859 9.375C17.4276 9.375 17.7109 9.65834 17.7109 10C17.7109 10.3417 17.4276 10.625 17.0859 10.625L3.06094 10.625C2.71927 10.625 2.43594 10.3417 2.43594 10C2.43594 9.65833 2.71927 9.375 3.06094 9.375Z' fill='currentColor'/></svg>";
                var icon_arrow_right = "<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M12.0233 4.31608C11.865 4.31608 11.7066 4.37442 11.5816 4.49942C11.34 4.74108 11.34 5.14108 11.5816 5.38275L16.1983 9.99941L11.5816 14.6161C11.34 14.8577 11.34 15.2577 11.5816 15.4994C11.8233 15.7411 12.2233 15.7411 12.465 15.4994L17.5233 10.4411C17.765 10.1994 17.765 9.79941 17.5233 9.55775L12.465 4.49942C12.34 4.37442 12.1816 4.31608 12.0233 4.31608Z' fill='currentColor'/><path d='M16.9391 9.375L2.91406 9.375C2.5724 9.375 2.28906 9.65834 2.28906 10C2.28906 10.3417 2.5724 10.625 2.91406 10.625L16.9391 10.625C17.2807 10.625 17.5641 10.3417 17.5641 10C17.5641 9.65833 17.2807 9.375 16.9391 9.375Z' fill='currentColor'/></svg>";
            }
            element.each( function(){
                var config = {
                    infinite: false,
                    arrows: $(this).data( 'nav' ),
                    dots: $(this).data( 'pagination' ),
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    prevArrow:"<button type='button' class='slick-arrow slick-prev'>"+ icon_arrow_left +"</button>",
                    nextArrow:"<button type='button' class='slick-arrow slick-next'>"+ icon_arrow_right +"</button>",
                };
            
                var slick = $(this);
                if( $(this).data('items') ){
                    config.slidesToShow = $(this).data( 'items' );
                    config.slidesToScroll = $(this).data( 'items' );
                }
                if( $(this).data('infinite') ){
                    config.infinite = true;
                }
                if( $(this).data('autoplay') ){
                    config.autoplay = true;
                    config.autoplaySpeed = 1500;
                    if( $(this).data('autoplaySpeed') ){
                        config.autoplaySpeed = $(this).data('autoplaySpeed');
                    }
                    config.pauseOnHover = true;
                }
                if( $(this).data('disable_draggable') ){
                    config.touchMove = false;
                    config.draggable = false;
                    config.swipe = false;
                    config.swipeToSlide = false;
                }
                if( $(this).data('centermode') ){
                    config.centerMode = true;
                }
                if( $(this).data('centerpadding') ){
                    config.centerPadding = $(this).data('centerpadding');;
                }
                if( $(this).data('vertical') ){
                    config.vertical = true;
                    config.verticalSwiping = true;
                }
                if( $(this).data('rows') ){
                    config.rows = $(this).data( 'rows' );
                }
                if( $(this).data('asnavfor') ){
                    config.asNavFor = $(this).data( 'asnavfor' );
                }
                if( $(this).data('slidestoscroll') ){
                    config.slidesToScroll = $(this).data( 'slidestoscroll' );
                }
                if( $(this).data('focusonselect') ){
                    config.focusOnSelect = $(this).data( 'focusonselect' );
                }

                if ($(this).data('laptop')) {
                    var laptop = $(this).data('laptop');
                } else {
                    var laptop = config.items;
                }
                if ($(this).data('large')) {
                    var large = $(this).data('large');
                } else {
                    var large = 4;
                }
                if ($(this).data('medium')) {
                    var medium = $(this).data('medium');
                } else {
                    var medium = 3;
                }
                if ($(this).data('small')) {
                    var small = $(this).data('small');
                } else {
                    var small = 2;
                }
                if ($(this).data('smallest')) {
                    var smallest = $(this).data('smallest');
                } else {
                    var smallest = 1;
                }


                if ($(this).data('slidestoscroll_laptop')) {
                    var slidestoscroll_laptop = $(this).data('slidestoscroll_laptop');
                } else {
                    var slidestoscroll_laptop = config.items;
                }
                if ($(this).data('slidestoscroll_large')) {
                    var slidestoscroll_large = $(this).data('slidestoscroll_large');
                } else {
                    var slidestoscroll_large = large;
                }
                if ($(this).data('slidestoscroll_medium')) {
                    var slidestoscroll_medium = $(this).data('slidestoscroll_medium');
                } else {
                    var slidestoscroll_medium = medium;
                }
                if ($(this).data('slidestoscroll_small')) {
                    var slidestoscroll_small = $(this).data('slidestoscroll_small');
                } else {
                    var slidestoscroll_small = small;
                }
                if ($(this).data('slidestoscroll_smallest')) {
                    var slidestoscroll_smallest = $(this).data('slidestoscroll_smallest');
                } else {
                    var slidestoscroll_smallest = smallest;
                }

                config.responsive = [

                    {
                        breakpoint: 577,
                        settings: {
                            slidesToShow: smallest,
                            slidesToScroll: slidestoscroll_smallest,
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: small,
                            slidesToScroll: slidestoscroll_small
                        }
                    },
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: medium,
                            slidesToScroll: slidestoscroll_medium
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: large,
                            slidesToScroll: slidestoscroll_large
                        }
                    },
                    {
                        breakpoint: 1440,
                        settings: {
                            slidesToShow: laptop,
                            slidesToScroll: slidestoscroll_laptop
                        }
                    }
                ];
                if ( $('html').attr('dir') == 'rtl' ) {
                    config.rtl = true;
                }

                $(this).slick( config );

            } );

            // Fix owl in bootstrap 5 tabs
            $('a[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
                var target = $(e.target).attr("href");
                var $slick = $(".slick-carousel", target);

                if ($slick.length > 0 && $slick.hasClass('slick-initialized')) {
                    $slick.slick('refresh');
                }
            });
        }
        
        backToTop() {
            var self = this;
            var progressPath = document.querySelector('#back-to-top path');
            if ( progressPath != null ){
                
                var pathLength = progressPath.getTotalLength();
                progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
                progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
                progressPath.style.strokeDashoffset = pathLength;
                progressPath.getBoundingClientRect();
                progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 15ms ease-in-out';    
                
                var updateProgress = function () {
                    var scroll = $(window).scrollTop();
                    var height = $(document).height() - $(window).height();
                    var progress = pathLength - (scroll * pathLength / height);
                    progressPath.style.strokeDashoffset = progress;
                }
                updateProgress();
                $(window).scroll(function () {
                    updateProgress();
                    if ($(this).scrollTop() > 50) {
                        $('#back-to-top').addClass('active');
                    } else {
                        $('#back-to-top').removeClass('active');
                    }
                });
                $('#back-to-top').on('click', function () {
                    $('html, body').animate({scrollTop: '0px'}, 800);
                    return false;
                });
            }
        }

        popupImage() {
            // popup
            $(".popup-image").magnificPopup({
                delegate:'a',
                type:'image',
                gallery:{enabled:true},
                closeBtnInside:false,
                zoom: {
                    enabled: true,
                    duration: 200
                }
            });
            $('.popup-video').magnificPopup({
                disableOn: 700,
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false
            });
            
            $('body').on('click', '.close-magnific-popup', function() {
                $.magnificPopup.close();
            });
        }

        searchHeader() {
            $('body').on('click', '.icon-search.cardraw , .modal-overlay, .modal__close-button', function(){
                $(this).closest('.site-header__search-wrap').find('.search-modal').toggleClass('active');
                $(this).closest('.site-header__search-wrap').find('.modal-overlay').toggleClass('active');
            });
        }
        
        collectionView() {
            $(document).on('click', '.js-btn-view', function(){
                var value = $(this).data('col');

                $('.js-btn-view').removeClass('active');
                $(this).addClass('active');

                $('.js-col').removeClass().addClass('js-col col-sm-6 col-6');
                if (value === 3) {
                    $('.js-col').addClass('col-lg-4');
                } else if(value === 4) {
                    $('.js-col').addClass('col-lg-3');
                } else if(value === 5) {
                    $('.js-col').addClass('col-lg-2-4');
                } else if(value === 6) {
                    $('.js-col').addClass('col-lg-2');
                };
            });
        }

        swatchCard() {
            $(document).on('click', '.js-swatch-card-item', function(){
                const newImage = $(this).data('image');
                const id = $(this).data('id');

                $(this).closest('.js-product-card').find('.js-swatch-card-item').removeClass('active');
                $(this).addClass('active');

                $(this).closest('.js-product-card').find('.product-card__image img').attr('srcset', newImage);
                $(this).closest('.js-product-card').find('.js-grid-cart').data('id', id);
            });
        }

        quickView() {
            var self = this;

            $(".quickview-qtity").on("click", function (e) {
                e.preventDefault();
                var $button = $(this);
                var oldValue = $button.closest('.popup-quantity').find("input.quickview-quantity").val();
                if ($button.text() == "+") {
                    var newVal = parseFloat(oldValue) + 1;
                } else {
                    // Don't allow decrementing below zero
                    if (oldValue > 1) {
                        var newVal = parseFloat(oldValue) - 1;
                    } else {
                        newVal = 1;
                    }
                }
                $button.closest('.popup-quantity').find("input.quickview-quantity").val(newVal);
            });

            // 1. show quick view
            $(document).on('click', '.js-btn-quickview', function() {
                var self = $(this);
                self.addClass('loading');
                var product_handle = self.data('handle');
                var desc = self.find('.txt-short').text();
                var quickviewAvaible = $(this).attr("data-pavailable");
                var quickview_color = $('#js-quickview-wrapper').data('color');
                var jdmgReview = $(this).attr("data-viewjdmg");
                $('#quickview-product-images').removeClass().empty();
                $('#js-quickview-wrapper').removeClass('loaded-quickview');
                $('.quickview-product-options').empty();

                $.getJSON({
                    url: '/products/' + product_handle + '.js?' + new Date().getTime()
                }).done(function(product) {
                    self.removeClass('loading');
                    $('#js-quickview-wrapper').addClass('modal fade show loaded-quickview').modal('show');

                    var title = product.title;
                    var type = product.type;
                    var vendor = product.vendor;
                    var price = 0;
                    var compare_price = 0;
                    var images = product.images;
                    var variants = product.variants;
                    var options = product.options;
                    var url = '/products/' + product_handle;


                    $('.quickview-product-title').text(title);
                    function renderReview(){
                        if(window.SPR &&  theme_opts.review ){
                            $('.quickview-product-rv').html(`<span class="shopify-product-reviews-badge" data-id="${product.id}"></span>`);
                            return window.SPR.registerCallbacks(),
                            window.SPR.initRatingHandler(),
                            window.SPR.initDomEls(),
                            window.SPR.loadProducts(),
                            window.SPR.loadBadges()
                        }
                        if(theme_opts.review && typeof jdgm !== 'undefined' ){
                            $('.quickview-product-rv').html(`<div class='pt-1 small' >${jdmgReview}</div>`);
                            return jdgm.customizeBadges();
                        }
                    }
                    renderReview();
                    $("#js-quickview-wrapper input.quickview-quantity").val(1);

                    $('.quickview-product-type').text(type);
                    $('.quickview-product-description').html(desc);
                    $('.quickview-view-product').attr('href', url);
                    $('.quickview-view-product').click(function(){
                      window.location.href = url;
                    });
                    $('.quickview-view-type').text(type);
                    $('.quickview-view-vendor').text(vendor);
                    if ($('.quickview-product-description').is(':empty')){
                        $('.quickview-product-description').removeClass('mb-1');
                    } else {
                        $('.quickview-product-description').addClass('mb-1');
                    }
                    $('.quickview-add-button').attr('data-handle', product_handle);

                    if(quickviewAvaible == 'true'){
                        $('.quickview-add-button').prop('disabled', false).html(theme_opts.strings.addToCart);
                    } else {
                        $('.quickview-add-button').prop('disabled', true).html(theme_opts.strings.soldOut);
                    }
                    $(product.variants).each(function(i,variants) {
                        if(variants.sku != null){
                            $('.quickview-sku').addClass("show").removeClass("hide");
                            $('.quickview-view-sku').text(product.variants[0].sku);
                        } else {
                            $('.quickview-sku').addClass("hide").removeClass("show");
                        }
                    });
                    var imageCount = $(images).length;
                    $(images).each(function(i, image) {
                        var image_embed = '<div><img role="presentation"  data-src="' + image+"&width=800" + '" srcset="' + image+"&width=800" + '" src="' + image+"&width=800" + '" ></div>';
                        $('#quickview-product-images').append(image_embed);
                    });
                    setTimeout(function(){
                        $('#quickview-product-images').slick({
                            rtl:theme_opts.rtl,
                            'dots': true,
                            'arrows': true,
                            'respondTo': 'min',
                            'useTransform': true
                        }).css('opacity', '1');
                    }, 200);
                    

                    if (product.variants[0].option1 !== "Default Title"){
                        $(options).each(function(i, option) {
                            var name = option.name;
                            var opt = name.replace(/ /g, '-').toLowerCase();
                            var selectClass = '.option.' + opt;
                            $('.quickview-product-options').append('<div class="option-selection ' + opt + '"><span class="option">' + option.name + ' :<span class="js-option-label-'+i+' ">'+option.values[0]+'</span></span><select class="option-' + i + ' option ' + opt + '"></select></div>').addClass('pb-3');
                            $(option.values).each(function(i, value) {
                                $('.option.' + opt).append($('<option>', {
                                    value: value,
                                    text: value
                                }));
                            });
                            //list
                            if ($("#js-quickview-wrapper").data('type') == 'list') {
                                var str = '<div class="single-option-radio js-option-' + i + ' ">';
                                if (option.name.includes(theme_opts.strings.colorVariant1) || option.name.includes(theme_opts.strings.colorVariant2)) {
                                    var k = i + 1;
                                }
                              
                                //option.values = option.values.sort();
                                $(option.values).each(function(i, value) {
                                    var cl="";
                                    if (i == 0){
                                        cl="active";
                                    }
                                    if (option.name.includes(theme_opts.strings.colorVariant1) || option.name.includes(theme_opts.strings.colorVariant2)) {
                                        var variant_img = '';
                                        for (var cc = 0; cc < variants.length; cc++) { 
                                            if (variants[cc]['option'+k] == value) {
                                                if (variants[cc]['featured_image'] && variants[cc]['featured_image']['src']) {
                                                    variant_img = variants[cc]['featured_image']['src'];
                                                }
                                            }
                                        }
                                      
                                        if (variant_img == '') {
                                            str += '<label class="'+cl+'" data-value="'+value+'">'+value+'</label>';
                                        } else {
                                            if(quickview_color) {
                                                var file = variant_img;
                                                var nvl = value.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase();
                                                const escapedValue = nvl;

                                                file = file.slice(0, file.lastIndexOf("/products"));
                                                str += `<label class="have-background st-color-${escapedValue} ${cl}" data-value="${value}" style="background-color:${value};"><span class="st-color-${escapedValue} st-color"></span><span>${value}</span></label>`;

                                            } else {
                                                str += '<label class="have-background '+cl+'" data-value="'+value+'" style="background-image:url('+variant_img+')">'+value+'</label>';    
                                            }
                                        }
                                      
                                    } else{
                                        str += '<label class="'+cl+'" data-value="'+value+'">'+value+'</label>';
                                    }
                                
                                });
                                str += '</div>';

                                $(`.option-selection.${opt}`).append(str);
                            }
                        });

                        if ($("#js-quickview-wrapper").data('type') == 'list') {
                            $("#js-quickview-wrapper .option-selection label").click(function(){
                      
                                $(this).closest('.option-selection').find('select').val($(this).data('value'));
                                $(this).closest('.option-selection').find('label').removeClass('active');
                                $(this).addClass('active');
                          
                                var arr_option = [];
                                $("#js-quickview-wrapper").find('select.option').each(function(){
                                    arr_option.push($(this).val());
                                });
                                var status = true;
                                var variant = '';
                                for (var i=0; i<variants.length; i++) {
                                    var status = true;
                                    for (var j=0; j<arr_option.length; j++) {
                                        if (arr_option[j] != variants[i]['options'][j]) {
                                            status = false;
                                        }
                                    }
                                    if (variants[i]['available'] == false) {
                                        status = false;
                                    }
                                    if (status == true) {
                                      variant = variants[i];
                                    }
                                }
                                //console.log(variant);
                                //console.log(variant['available']);
                                if (variant != '' || variant['available']) {
                                    $(".quickview-add-button").prop( "disabled", false );
                                
                                } else {
                                    $(".quickview-add-button").prop("disabled", true).html(theme_opts.strings.unavailable);
                                }
                          
                          
                                var selectedOptions = '';
                                $('#js-quickview-wrapper select').each(function(i) {
                                    if (selectedOptions == '') {
                                      selectedOptions = $(this).val();
                                    } else {
                                      selectedOptions = selectedOptions + ' / ' + $(this).val();
                                    }
                                });
                                var targetVl = $(this).data("value");
                                for (i=0; i<variants.length; i++) {
                                    $(this).closest('.option-selection').find('.js-option-label-'+i+'').text(targetVl);
                                }
                          
                                jQuery.getJSON(`/products/${product_handle}.js`, function(product) {
                                    $(product.variants).each(function(i, v) {
                                        if (v.title == selectedOptions) {
                                            if (v.featured_image !== null){
                                                var iSlick = v.featured_image.position - 1;
                                                $('#quickview-product-images').slick('slickGoTo', iSlick);
                                            }
                                            var price = Shopify.formatMoney(v.price, theme_opts.moneyFormat);
                                            var compare_price = Shopify.formatMoney(v.compare_at_price, theme_opts.moneyFormat);
                                            $('.quickview-product-price').html(price);
                                            $('.quickview-product-compare-price').html(compare_price);
                                            if (v.compare_at_price !== null) {
                                                $('.quickview-product-compare-price').html(compare_price).show();
                                            } else {
                                                $('.quickview-product-compare-price').hide();
                                            }
                                            //theme_opts.updateCurrencies();
                                            
                                            if (v) {
                                                if (v.available == true) {
                                                    $('.quickview-add-button').prop('disabled', false).html(theme_opts.strings.addToCart);
                                                } else {
                                                    $('.quickview-add-button').prop('disabled', true).html(theme_opts.strings.soldOut);
                                                }
                                            } else {
                                                $('.quickview-add-button').prop('disabled', false).html(theme_opts.strings.unavailable);
                                            }
                                        }
                      
                                    });
                                });
              
                            });
                        }
                    }

                    $(product.variants).each(function(i, v) {
                        price = Shopify.formatMoney(v.price, theme_opts.moneyFormat);
                        compare_price = Shopify.formatMoney(v.compare_at_price, theme_opts.moneyFormat);
                        $('.quickview-product-price').html(price);
                        if (v.compare_at_price !== null) {
                            $('.quickview-product-compare-price').html(compare_price).show();
                        } else {
                            $('.quickview-product-compare-price').hide();
                        }
                        //theme_opts.updateCurrencies();
                        //v.inventory_quantity == 0 && v.inventory_management == 'shopify'
                        if (v.inventory_quantity == 0 && v.inventory_management == 'shopify') {
                            $('.quickview-add-button').prop('disabled', true).val(theme_opts.strings.soldOut);
                            return true
                        } else {
                            $('select.option-0').val(v.option1);
                            $('select.option-1').val(v.option2);
                            $('select.option-2').val(v.option3);
                            return false
                        }
                    });


                }).fail(function() {
                    console.log( "error" );
                });

                
            });

            $('#js-quickview-wrapper').on("hidden.bs.modal", function () {
                $('#js-quickview-wrapper').removeClass('loaded-quickview');
            });
        }

        quickViewAddCart() {
            var self = this;
            // 2. Add to cart
            $(document).on('click','.quickview-add-button', function() {
                var product_handle = $(this).data('handle');
                
                var qty = $('.quickview-quantity').val(),
                    selectedOptions = '',
                    var_id = '';
                function processCart() {
                    $.post({
                        url: '/cart/add.js',
                        data: {
                            quantity: qty,
                            id: var_id
                        },
                        dataType: 'json',
                        beforeSend: function() {
                            $('.quickview-add-button').addClass('loading');
                        }
                    }).done(function(item) {
                        var htmlVariant = item.variant_title !== null ? '<i>('+item.variant_title+')</i>' : '';
                        var styleCart = $('.js-mini-cart').attr("data-cartmini");
                        
                        if(styleCart != 'true'){
                            var htmlAlert = '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="'+item.image+'"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">'+item.product_title+' x '+ item.quantity +'</p>'+htmlVariant+'<div><div>';
                            self.createAlert(theme_opts.strings.addToCartSuccess, htmlAlert, 'notice');
                        }
                        
                        self.updateElements();
                        self.generateCart();

                        if (theme_opts.cartpage) {
                            location.reload();
                            $("html, body").animate({ scrollTop: 0 }, "slow");
                        }
                    }).fail(function($xhr) {
                        var data = $xhr.responseJSON;
                        self.createAlert('', data.description, 'warning');
                    }).always(function() {
                        $('.quickview-add-button').prop('disabled', false).removeClass('loading');
                        $('#js-quickview-wrapper').modal('hide');
                    });
                }
                $('#js-quickview-wrapper select').each(function(i) {
                    if (selectedOptions == '') {
                        selectedOptions = $(this).val();
                    } else {
                        selectedOptions = selectedOptions + ' / ' + $(this).val();
                    }
                });
                jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
                    if (product.variants.length === 1){
                        var_id = product.variants[0].id;
                    } else {
                        $(product.variants).each(function(i, v) {
                            if (v.title == selectedOptions) {
                                var_id = v.id;
                            }
                        });
                    }
                    processCart();
                });
            });
        }

        quickViewSelectVariants() {
            var self = this;
            // 3. Select variants
            $(document).on('change', '#js-quickview-wrapper select', function() {
                var selectedOptions = '';
                $('#js-quickview-wrapper select').each(function(i) {
                    if (selectedOptions == '') {
                        selectedOptions = $(this).val();
                    } else {
                        selectedOptions = selectedOptions + ' / ' + $(this).val();
                    }
                });
                jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
                    $(product.variants).each(function(i, v) {
                    
                        if (v.title == selectedOptions) {
                            if (v.featured_image !== null){
                                var iSlick = v.featured_image.position - 1;
                                $('#quickview-product-images').slick('slickGoTo', iSlick);
                            }
                            var price = Shopify.formatMoney(v.price, theme_opts.moneyFormat);
                            var compare_price = Shopify.formatMoney(v.compare_at_price, theme_opts.moneyFormat);
                            $('.quickview-product-price').html(price);
                            $('.quickview-product-compare-price').html(compare_price);
                            if(v.sku != null){
                                $('.quickview-sku').addClass("show").removeClass("hide");
                                $('.quickview-view-sku').text(v.sku);
                            } else {
                                $('.quickview-sku').addClass("hide").removeClass("show");
                            }
                            if (v.compare_at_price !== null) {
                                $('.quickview-product-compare-price').html(compare_price).show();
                            } else {
                                $('.quickview-product-compare-price').hide();
                            }
                            //theme_opts.updateCurrencies();
                            if (v.inventory_management === null) {
                                $('.quickview-add-button').prop('disabled', false).val(theme_opts.strings.addToCart);
                            } else {
                                if (v.inventory_quantity < 1) {
                                    $('.quickview-add-button').prop('disabled', true).val(theme_opts.strings.soldOut);
                                } else {
                                    $('.quickview-add-button').prop('disabled', false).val(theme_opts.strings.addToCart);
                                }
                            }
                        }
                    });
                });
            });
        }

        miniCart() {
            var self = this;
            var $this = this;

            $('body').on('click', '.header-cart-icon, .overlaycart, .close-mini-cart', function(){
                
                $(this).closest('.js-mini-cart').toggleClass('active');
                $(this).closest('.js-mini-cart').find('.overlaycart').toggleClass('active');
            });

            var numberDisplayed = 5;
            // 2. Button remove items
            $(document).on('click','.js-remove-mini-cart',function(){
                var itemId = $(this).data('id');
                var isOuterMiniCart = $(this).closest('.js-mini-cart').length === 0? true : false;  // check element from mini cart or not
                
                // hide items
                $(this).parents('.mini-cart-item').fadeOut();
                
                //remove from cart
                Shopify.changeItem(itemId,0, $this.updateElements);
                Shopify.getCart(function(cart){
                    if (cart.items.length > numberDisplayed || isOuterMiniCart) {
                        $this.generateCart();
                    }
                });
            });

            // gen minicart when load page
            $this.generateCart();
        }

        addToCart() {
            var self = this;
            var buttonClass = '.js-grid-cart';
            $(document).on('click', buttonClass,function(){
                var $this = $(this);
                var id = $this.data('id');
                $this.addClass('loading');
                if (Shopify) {
                    Shopify.addItem(id,1,function(item){
                        var htmlVariant = item.variant_title !== null ? '<i>('+item.variant_title+')</i>' : '';
                        var styleCart = $('.js-mini-cart').attr("data-cartmini");

                        if (styleCart != 'true') {
                          var htmlAlert = '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="'+item.image+'"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">'+item.product_title+' x '+ item.quantity +'</p>'+htmlVariant+'<div><div>';
                        }
                        self.generateCart();
                        self.updateElements();
                        setTimeout(function() {
                            styleCart != 'true' ? self.createAlert(theme_opts.strings.addToCartSuccess, htmlAlert, 'notice'): '';
                        
                            $this.removeClass('loading');
                        }, 300);
                        if(theme_opts.cartpage){
                          location.reload();
                          $("html, body").animate({ scrollTop: 0 }, "slow");
                        }
                    });
                }
            });
        }

        updateElements(){
            var self = this;
            var buttonHtml = '<a class="btn btn-primary w-100 mt-4" href='+theme_opts.strings.cartCollection+'>'+theme_opts.strings.cartEmptyButton+'</a>';
            var emptyCartHTML = '<div class="alert mini-cart-empty"><div class="text-center"><div class="iconcart-empty">'+theme_opts.strings.cartIcon+'</div><div class="txtcart-empty mt-4">'+theme_opts.strings.cartEmpty+'</div>'+buttonHtml+'</div></div>';
            var styleCart = $('.js-mini-cart').attr("data-cartmini");

            Shopify.getCart(function(cart){
                if (cart.item_count === 0) {
                    $('.js-mini-cart-content').html(emptyCartHTML);
                    $(`.js-cart-bottom, .drawer-crossell`).hide(100);
                    styleCart === 'true' ? $('.js-mini-cart').removeClass('active') : null;
                    styleCart === 'true' ? $('.js-mini-cart .overlaycart').removeClass('active') : null;

                } else {
                    $(`.js-cart-bottom, .drawer-crossell`).show(100);
                    styleCart === 'true' ? $('.js-mini-cart').addClass('active') : null;
                    styleCart === 'true' ? $('.js-mini-cart .overlaycart').addClass('active') : null;
                }
                $('.js-cart-count').text(cart.item_count);
                $('.js-cart-total').html(Shopify.formatMoney(cart.total_price, theme_opts.moneyFormat));

                self.freeShipping(cart);
            });
        }

        generateCart() {
            var self = this;

            var cartimgsize = $('.js-mini-cart-content').attr('data-sizeimg');
            var numberDisplayed = 5;
            var buttonHtml = '<a class="btn btn-primary w-100 mt-4" href='+theme_opts.strings.cartCollection+'>'+theme_opts.strings.cartEmptyButton+'</a>';
            var emptyCartHTML = '<div class="alert mini-cart-empty"><div class="text-center"><div class="iconcart-empty">'+theme_opts.strings.cartIcon+'</div><div class="txtcart-empty mt-4">'+theme_opts.strings.cartEmpty+'</div>'+buttonHtml+'</div></div>';
            var styleCart = $('.js-mini-cart').attr("data-cartmini");

            Shopify.getCart(function(cart) {
                var htmlCart = cart.item_count === 0? emptyCartHTML:'',
                    itemCount = cart.items.length,
                    forLoop = itemCount < numberDisplayed ? itemCount : numberDisplayed;

                self.checkGift(cart);

                if (cart.item_count === 0) {  
                    $(`.js-cart-bottom, .drawer-crossell`).hide(100);
                } else {    
                    $(`.js-cart-bottom, .drawer-crossell`).show(100);
                }

                // add list items
                for (let i = 0; i < forLoop; i++) {
                    var trash = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.8499 9.14014L18.1999 19.2101C18.0899 20.7801 17.9999 22.0001 15.2099 22.0001H8.7899C5.9999 22.0001 5.9099 20.7801 5.7999 19.2101L5.1499 9.14014" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.3301 16.5H13.6601" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 12.5H14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                    var line = i+1;
                    var product = cart.items[i],
                    productPrice = Shopify.formatMoney(product.price, theme_opts.moneyFormat);

                    htmlCart += `<div class="mini-cart-item">`;
                    htmlCart += `   <a class="mini-cart-image " href="${product.url}"> <span class="d-block mini-cart-img ${cartimgsize}">`;
                    htmlCart += `       <img src="${product.image}&width=160"/>`;
                    htmlCart += `   </span></a>`;
                    htmlCart += `   <div class="mini-cart-meta">`;
                    htmlCart += `       <div class="name-product"><a href="${product.url}">${product.title}</a></div>`;
                    htmlCart += `       <div class="d-flex align-items-center info"><span>${productPrice}</span> x ${product.quantity}</div><div class="d-flex align-items-center mt-2"><div class="js-qty product-form__item--quantity d-flex"><button type="button" class="js-qty__adjust js-qty__minus quantity-minus quantity-qtity" aria-label="Reduce item quantity by one"><span class="icon__fallback-text">−</span></button><input data-line="`+ line + `" type="text" min="0" class="product-form__input change-minicart js-qty__input" pattern="[0-9]*" value="${product.quantity}"><button type="button" class="js-qty__adjust js-qty__plus quantity-plus quantity-qtity" aria-label="Increase item quantity by one"><span class="icon__fallback-text">+</span></button></div><button class="js-remove-mini-cart" data-id="${product.id}">${trash}</button></div>`;
                    htmlCart += `   </div>`;
                    htmlCart += `</div>`;
                }

                if (itemCount > numberDisplayed){
                    htmlCart += '<p><a class="js-btn-viewmore small" href="/cart">'+' ('+(itemCount - numberDisplayed)+')</a></p>'
                }
                // add total price and cart button / checkout button
                $('.js-mini-cart-content').html(htmlCart);

                
              
                $('.js-cart-total').html(Shopify.formatMoney(cart.total_price, theme_opts.moneyFormat));
            });
        }

        cartChangeQty() {
            var self = this;

            $(document).on('click', '.js-qty__minus', function(){
                if ($(this).parent().find('input').val() < 1) {
                    $(this).parent().find('input').val(0);
                } else {
                    $(this).parent().find('input').val(parseInt($(this).parent().find('input').val()) - 1);
                }
                var qty = $(this).parent().find('input').val();
                var line = $(this).parent().find('input').data('line');
                jQuery.post('/cart/change.js', {
                    quantity: qty,
                    line: line
                },null,"json").done(function(item) {
                    self.updateElements();
                    self.generateCart();
                })
            });

            $(document).on('click', '.js-qty__plus', function(){
                $(this).parent().find('input').val(parseInt($(this).parent().find('input').val()) + 1);
                
                var qty = $(this).parent().find('input').val();
                var line = $(this).parent().find('input').data('line');
                jQuery.post('/cart/change.js', {
                    quantity: qty,
                    line: line
                },null,"json").done(function(item) {
                    self.updateElements();
                    self.generateCart();
                });
                
            });
        }
        
        freeShipping(cart) {
            var minOrderValue = parseInt($('.js-free-shipping').data('value')) || 0;
            var $percentClass = $('.js-free-shipping .progress-bar');

            var priceCart = cart.total_price;
            priceCart == 0 ? $('.js-free-shipping').hide() : $('.js-free-shipping').show();
            if (priceCart >= minOrderValue){
                $percentClass.css('width','100%').removeClass('progress-bar-striped bg-primary');
                $('.js-free-shipping-text').text(theme_opts.strings.freeShipping);
                $('.js-free-shipping-text').prev('svg').removeClass('hide');
            } else {
                let percent = priceCart / minOrderValue * 100;
                let left = Shopify.formatMoney((minOrderValue - priceCart),theme_opts.moneyFormat);
                $percentClass.css('width',percent+'%').addClass('progress-bar-striped primary');
                $('.js-free-shipping-text').html($('.js-free-shipping').attr('data-start') +' '+ left +' '+ $('.js-free-shipping').attr('data-end'));
                $('.js-free-shipping-text').prev('svg').removeClass('hide');
                //theme_opts.updateCurrencies();
            }
        }

        currencyFormatMoney(cents, format) {
            if (typeof cents === 'string') {
                cents = cents.replace('.', '');
            }
            var value = '';
            var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            var formatString = format || '${{amount}}';

            switch (formatString.match(placeholderRegex)[1]) {
                case 'amount':
                    value = this.formatWithDelimiters(cents, 2);
                break;
                case 'amount_no_decimals':
                    value = this.formatWithDelimiters(cents, 0);
                break;
                case 'amount_with_comma_separator':
                    value = this.formatWithDelimiters(cents, 2, '.', ',');
                break;
                case 'amount_no_decimals_with_comma_separator':
                    value = this.formatWithDelimiters(cents, 0, '.', ',');
                break;
                case 'amount_no_decimals_with_space_separator':
                    value = this.formatWithDelimiters(cents, 0, ' ');
                break;
                case 'amount_with_apostrophe_separator':
                    value = this.formatWithDelimiters(cents, 2, "'");
                break;
            }
            return formatString.replace(placeholderRegex, value);
        }

        formatWithDelimiters(number, precision, thousands, decimal) {
            thousands = thousands || ',';
            decimal = decimal || '.';

            if (isNaN(number) || number === null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                '$1' + thousands
            );
            var centsAmount = parts[1] ? decimal + parts[1] : '';

            return dollarsAmount + centsAmount;
        }

        processWishlist() {
            var self = this;
            var wishlist = JSON.parse(localStorage.getItem('localWishlist')) || [];

            $(document).on('click', '.js-btn-wishlist', function (event) {
                event.preventDefault();
                self.updateWishlist(this);
            });

            $(document).on('click', '.js-remove-wishlist', function () {
                const productHandle = $(this).data('handle');
                const allSimilarProducts = $(`.js-btn-wishlist[data-handle="${productHandle}"]`);

                allSimilarProducts.html(`${theme_opts.strings.wishlistIcon}${theme_opts.strings.wishlistText}`);
                allSimilarProducts.attr('data-bs-original-title', theme_opts.strings.wishlistText);

                const productIndex = wishlist.indexOf(productHandle);
                if (productIndex !== -1) {
                    wishlist.splice(productIndex, 1);
                    localStorage.setItem('localWishlist', JSON.stringify(wishlist));
                }

                $(this).closest('.js-wishlist-item').fadeOut(() => {
                    $(this).remove();
                    if (wishlist.length === 0) {
                        // no result
                        $('.js-wishlist-content').html(`
                          <div class="col text-center">
                            <div class="alert alert-warning d-inline-block">${theme_opts.strings.wishlistNoResult}</div>
                          </div>
                        `);
                    }
                });

                $('.js-wishlist-count').text(wishlist.length);
            });

            


            self.loadWishlist();
            $(document).on('shopify:section:load', self.loadWishlist);
        }

        updateWishlist($this) {
            var self = this;
            var wishlist = JSON.parse(localStorage.getItem('localWishlist')) || [];
            const productHandle = $($this).data('handle');
            const allSimilarProducts = $(`.js-btn-wishlist[data-handle="${productHandle}"]`);
            const isAdded = wishlist.includes(productHandle);

            if (isAdded) {
                window.location.href = $('.js-wishlist-link').attr('href');
            } else {
                wishlist.push(productHandle);
                allSimilarProducts.fadeOut('slow').fadeIn('fast').html(`${theme_opts.strings.wishlistIcon}${theme_opts.strings.wishlistTextAdded}`);
                allSimilarProducts.attr('data-bs-original-title', theme_opts.strings.wishlistTextAdded);
                allSimilarProducts.addClass('added');


                $('.tooltip-inner').text(theme_opts.strings.wishlistTextAdded);
            }

            localStorage.setItem('localWishlist', JSON.stringify(wishlist));
            $('.js-wishlist-count').text(wishlist.length);
        }

        loadWishlist() {
            var wishlist = JSON.parse(localStorage.getItem('localWishlist')) || [];
            $('.js-wishlist-content').empty();

            if (wishlist.length > 0) {
                wishlist.forEach((productHandle) => {
                    jQuery.getJSON(window.Shopify.routes.root + `products/${productHandle}.js`, function(product) {
                      const productPrice = product.price_varies
                        ? `from ${Shopify.formatMoney(product.price_min, theme_opts.moneyFormat)}`
                        : Shopify.formatMoney(product.price, theme_opts.moneyFormat);
                      const productComparePrice = product.compare_at_price_min !== 0
                        ? Shopify.formatMoney(product.compare_at_price_min, theme_opts.moneyFormat)
                        : '';

                      const htmlProduct = `
                        <div class="js-wishlist-item col-md-4 col-sm-6 col-6 col-12 mb-3 mb-md-4">
                          <div class="js-wishlist-itembox">
                            <div class="d-flex column-gap-3 align-items-center">
                              <a class="flex-shrink-0 d-block js-wishlist-left" href="${product.url}">
                                <img class="lazyload" data-src="${product.featured_image}&width=300" alt="${product.title}" />
                              </a>
                              <div class="flex-grow-1">
                                <a href="${product.url}" class="d-block product-card__name mb-1">${product.title}</a>
                                <div class="wl-price d-flex align-items-center column-gap-2">
                                    <span class="price_last">${productPrice}</span>
                                    <s>${productComparePrice}</s>
                                </div>
                                <div><button class="js-remove-wishlist link small d-inline-flex align-items-center column-gap-1" data-handle="${product.handle}"><span class="ti-close"></span> ${theme_opts.strings.wishlistRemove}</button></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      `;

                      $('.js-wishlist-content').append(htmlProduct);
                    });
                });
            } else {
                // no result
                $('.js-wishlist-content').html(`
                  <div class="col text-center">
                    <div class="alert alert-warning d-inline-block">${theme_opts.strings.wishlistNoResult}</div>
                  </div>
                `);
            }

            $('.js-wishlist-count').text(wishlist.length);


            $('.js-btn-wishlist').each(function () {
                const handle = $(this).data('handle');
                const isProductAdded = wishlist.includes(handle);
                const addClass = isProductAdded ? 'added' : '';
                const iconWishlist = theme_opts.strings.wishlistIcon;
                const textWishlist = isProductAdded ? theme_opts.strings.wishlistTextAdded : theme_opts.strings.wishlistText;

                $(this).html(`${iconWishlist}${textWishlist}`).attr('title', textWishlist).addClass(addClass).attr('data-bs-original-title', textWishlist);
                
            });
        }

        processCompare() {
            var self = this,
                compareObject = JSON.parse(localStorage.getItem('localCompare')) || [];

            $(document).on('click','.js-btn-compare',function (event) {
                event.preventDefault();
                self.updateCompare($(this));
                self.loadCompare();
            });
            $(document).on('click','.js-remove-compare',function(){
                var compareObject = JSON.parse(localStorage.getItem('localCompare')) || [];
                var productHandle = $(this).data('handle');
                compareObject.splice(compareObject.indexOf(productHandle), 1);
                localStorage.setItem('localCompare', JSON.stringify(compareObject)); 
                self.loadCompare();
            });

            $(document).on('click', '.compare-sidebar-btn', function(){
                self.loadCompare();
            });

            if ( compareObject.length ) {
                $('.compare-sidebar-btn').addClass('active');
                $('.compare-sidebar-btn .js-compare-count').text(compareObject.length);
            }
        }

        updateCompare($this) {
            var self = this;
            var productHandle = $this.data('handle'),
                alertText = '',
                compareObject = JSON.parse(localStorage.getItem('localCompare')) || [],
                alertClass='notice';

            var isAdded = $.inArray(productHandle,compareObject) !== -1 ? true:false;
            if (isAdded) {
                compareObject.splice(compareObject.indexOf(productHandle), 1);
                alertText = theme_opts.strings.compareNotifyRemoved;
                alertClass = 'notice';
            } else {
                if (compareObject.length === 4) {
                    alertText = theme_opts.strings.compareNotifyMaximum;
                    alertClass = 'error';
                } else {
                    alertClass = 'notice';
                    compareObject.push(productHandle);
                    alertText = theme_opts.strings.compareNotifyAdded;
                }
            }
            localStorage.setItem('localCompare', JSON.stringify(compareObject)); 
            self.createAlert(theme_opts.strings.compareText, alertText, alertClass);
            
            $('.compare-sidebar-btn .js-compare-count').text(compareObject.length);
            if ( compareObject.length ) {
                $('.compare-sidebar-btn').addClass('active');
            } else {
                $('.compare-sidebar-btn').removeClass('active');
            }
        }

        loadCompare(){
            var self = this;
            var compareObject = JSON.parse(localStorage.getItem('localCompare')) || [];

            $('.js-compare-content .js-new-cell').remove();
            //popup compare
            if (compareObject.length > 0) {


                for (var i = 0; i < compareObject.length; i++) {
                    var productHandle = compareObject[i];

                    Shopify.getProduct(productHandle,function(product){
                        var htmlProduct = '',
                            productPrice = product.price_varies? 'from ' + Shopify.formatMoney(product.price_min, theme_opts.moneyFormat) : Shopify.formatMoney(product.price, theme_opts.moneyFormat),
                            productComparePrice = product.compare_at_price_min !== 0 ? Shopify.formatMoney(product.compare_at_price_min, theme_opts.moneyFormat) : '',
                            productAvailable = product.available ? theme_opts.strings.available : theme_opts.strings.unavailable,
                            productAvailableClass = product.available ? 'bg-success' : 'bg-danger',
                            productTypeHTML = product.type !== "" ? '<a class="link" href="/collections/types?q='+ product.type +'">'+ product.type +'</a>' : '<span>'+ theme_opts.strings.none +'</span>',
                            productVendorHTML = product.vendor !== "" ? '<a class="link" href="/collections/vendors?q='+ product.vendor +'">'+ product.vendor +'</a>' : '<span>'+ theme_opts.strings.none +'</span>';

                            htmlProduct = '<div class="d-table-cell p-2 border js-new-cell text-center">';
                            htmlProduct += '<button class="js-remove-compare link " data-handle="'+product.handle+'"><span class="ti-close"></span>'+ theme_opts.strings.compareTextRemove +'</button>';
                            htmlProduct += '</div>';
                            $('.js-remove-row').append(htmlProduct);

                            htmlProduct = '<div class="d-table-cell p-4 border js-new-cell text-center">';
                            htmlProduct += '<div class="product-name"><a href="'+ product.url +'">'+ product.title +'</a></div>';
                            htmlProduct += '  <a href="'+ product.url +'">';
                            htmlProduct += '      <img src="'+ Shopify.resizeImage(product.featured_image,'x300') +'"/>';
                            htmlProduct += '  </a>';
                            htmlProduct += '  </div>';
                            $('.js-product-row').append(htmlProduct);

                            htmlProduct = '<div class="d-table-cell p-2 border js-new-cell">';
                            htmlProduct += '<div class="productPrice d-flex column-gap-1 align-items-center"><s class="small">'+ productComparePrice +'</s>';
                            htmlProduct += '<div class="price"> '+ productPrice +'</div></div>';
                            htmlProduct += '</div>';
                            $('.js-price-row').append(htmlProduct);

                            htmlProduct = '<div class="d-table-cell p-2 border js-new-cell">';
                            htmlProduct += '<div><span class="badge '+ productAvailableClass +'"> '+ productAvailable +'</span></div>';
                            htmlProduct += '</div>';
                            $('.js-available-row').append(htmlProduct);

                            htmlProduct = '<div class="d-table-cell p-2 border js-new-cell">';
                            htmlProduct += product.type !== "" ? '<a class="link" href="/collections/types?q='+ product.type +'">'+ product.type +'</a>' : '<span>'+ theme_opts.strings.none +'</span>';
                            htmlProduct += '</div>';
                            $('.js-type-row').append(htmlProduct);

                            htmlProduct = '<div class="d-table-cell p-2 border js-new-cell">';
                            htmlProduct += product.vendor !== "" ? '<a class="link" href="/collections/vendors?q='+ product.vendor +'">'+ product.vendor +'</a>' : '<span>'+ theme_opts.strings.none +'</span>';
                            htmlProduct += '</div>';
                            $('.js-vendor-row').append(htmlProduct);

                            $('.js-view-product-row').append(htmlProduct);
                    });

                }

                // open popup
                setTimeout(function(){
                    $('#js-compare-wrapper').modal('show');
                }, 1000);
            } else {
                // open popup
                $('.js-compare-content').html( "<div class='text-center w-100 text-danger'>"+ theme_opts.strings.compareNoResult+"</div>");
                $('#js-compare-wrapper').modal('show');
            }
            
            //button text
            $('.js-btn-compare').each(function(){
                var productHandle = $(this).data('handle');
                var status = $.inArray(productHandle, compareObject) !== -1 ? 'added' : '';
                $(this).removeClass('added').addClass(status);
            });

            //count items
            $('.compare-sidebar-btn .js-compare-count').text(compareObject.length);
            if ( compareObject.length ) {
                $('.compare-sidebar-btn').addClass('active');
            } else {
                $('.compare-sidebar-btn').removeClass('active');
            }
        }

        productDetails() {
            var self = this;
            // quantity
            $(".quantity-qtity").on("click", function (e) {
                e.preventDefault();
                var oldValue = $(this).closest('.quantity-wrapper').find("input[name=quantity]").val();
                if ($(this).text() == "+") {
                    var newVal = parseFloat(oldValue) + 1;
                } else {
                    // Don't allow decrementing below zero
                    if (oldValue > 1) {
                        var newVal = parseFloat(oldValue) - 1;
                    } else {
                        newVal = 1;
                    }
                }
                $(this).closest('.quantity-wrapper').find("input[name=quantity]").val(newVal);
            });

            // add to cart
            $(document).on('submit', 'form[action="/cart/add"]', function (e) {
                e.preventDefault();
                var $form = $(this);
                var $submitButton = $form.find('button[type="submit"]');
                $submitButton.addClass('loading');

                var showNotice  = $form.hasClass('js-form--notice') ? true : false;
                var styleCart = $('.js-mini-cart').attr("data-cartmini");
                var params = {
                    type: 'POST',
                    url: '/cart/add.js',
                    data: $(this).serialize(),
                    dataType: 'json',
                    success: $.proxy(function(item) {
                        self.updateElements();
                        self.generateCart();

                        if(styleCart != 'true' ) {
                            if ( showNotice ) {
                                var htmlVariant = item.variant_title !== null ? '<i>('+item.variant_title+')</i>' : '';
                                var htmlAlert = '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="'+item.image+'"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">'+item.product_title+' x '+ item.quantity +'</p>'+htmlVariant+'<div><div>';
                                self.createAlert(theme_opts.strings.addToCartSuccess, htmlAlert, 'notice');
                            } else {
                                self.showPopupCrosssell(item);
                            }
                        }
                    }, this),
                    error: $.proxy(function(XMLHttpRequest, textStatus) {
                        var data = JSON.parse(XMLHttpRequest.responseText);
    
                        if (data.message) {
                          self.createAlert('', data.description, 'warning');
                        }
                    }, this),
                    complete: function() {
                        $submitButton.removeClass('loading');
                    }
                };
                $.ajax(params);
            });

            // init variants
            var $form = $('form[action="/cart/add"]');
            var variant = self.getVariantFromOptions($form);
            if (variant) {

                // FIX: sync hidden variant-id <select name="id"> so Add to Cart submits the correct variant
                $('#ProductSelect-' + $form.data('section-id')).val(variant.id);

                //
                self.variantUpdateAddToCartBtn(variant, $form);
                
                // sticky cart
                self.variantUpdateStickyCart(variant);

                // price
                self.variantUpdatePrice(variant);

                // sku
                self.variantUpdateSKU(variant);

                // image
                self.variantUpdateImages(variant, $form);

                // swatch
                self.variantUpdateSwatchTitle(variant);
            }

            // Update Variants
            $(document).on('change', 'form[action="/cart/add"] select, form[action="/cart/add"] input[type=radio]', function () {
                var $form = $(this).closest('form');
                var variant = self.getVariantFromOptions($form);
                if (!variant) return;

                // FIX: sync hidden variant-id <select name="id"> so Add to Cart submits the correct variant
                $('#ProductSelect-' + $form.data('section-id')).val(variant.id);

                //
                self.variantUpdateAddToCartBtn(variant, $form);
                
                // sticky cart
                self.variantUpdateStickyCart(variant);

                // price
                self.variantUpdatePrice(variant);

                // sku
                self.variantUpdateSKU(variant);

                // image
                self.variantUpdateImages(variant, $form);

                // swatch
                self.variantUpdateSwatchTitle(variant);

                // UPDATE URL
                if (history.replaceState) {
                    var url = new URL(window.location.href);
                    url.searchParams.set('variant', variant.id);
                    history.replaceState({}, '', url);
                }


                $(document).trigger('variant:change', {
                    variant: variant,
                    form: $form
                });
            });

            // upsell popup
            const delayTime = $('#js-upsell-product').data('delay') || 3000;
            setTimeout(() => {
                $('#js-upsell-product').modal('show');
            }, delayTime);

            $('#js-upsell-product .btn.js-btn-accept').on('click', function() {
                const upsellProductId = $('#js-upsell-product').data('id') || '';
                Shopify.addItem(upsellProductId, 1, item => {
                    self.updateElements();
                    self.generateCart();

                    const variantInfo = item.variant_title !== null ? `<i>(${item.variant_title})</i>` : '';
                    const alertContent = `<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="${item.image}"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">${item.product_title} x ${item.quantity}</p>${variantInfo}<div><div>`;
                    
                    self.createAlert(theme_opts.strings.addToCartSuccess, alertContent, 'notice');
                });

                $('#js-upsell-product').modal('hide');
            });

            $('#js-upsell-product .btn.btn-decline').on('click', function() {
                $('#js-upsell-product').modal('hide');
            });


            // crossell
            var handles = $('.js-crosssell-handles').data('handles') || '',
                arrayHandle = handles.split(',');
            if (handles !== '') {
                $(document).on('click','.cross-item-image',function(event){
                    event.preventDefault();
                    var parent = $(this).closest('.cross-item'),
                        itemId = parent.find('.js-cross-select').attr('data-item');
                    Shopify.addItem(itemId,1,function(lineItem){
                        self.updateElements();
                        self.generateCart();
                        self.showPopupCrosssell(lineItem);
                    });
                });
                $(document).on('change', '.js-cross-select',function(){
                    var selectVariant = $(this).children(':selected'),
                      selectVariantId = selectVariant.data('id'),
                      parent = $(this).parent(),
                      newPrice = Shopify.formatMoney(selectVariant.data('price'), theme_opts.moneyFormat);

                    if (selectVariant.data('image') !== ''){
                        parent.find('.cross-item-image').find('img').attr('src',selectVariant.data('image'));
                    }
                    $(this).attr('data-item', selectVariantId);
                    parent.find('.cross-item-money').html(newPrice);
                    //theme_opts.updateCurrencies();
                });
                $(document).on('shopify:section:load', self.generateCrosssell);
                self.generateCrosssell();
                $('.block-cross-sell').removeClass('hide');
            }

            // Recent viewed
            var $el = $('recently-productsviewed');
            if ($el.length) {

                var observer = new IntersectionObserver(function (entries) {

                    entries.forEach(function (entry) {

                        if (entry.isIntersecting) {

                            observer.unobserve(entry.target);

                            var items = JSON.parse(localStorage.getItem('recentlyviewed') || '[]');

                            var excludeId = $el.attr('exclude-product-id');

                            if (excludeId) {
                                excludeId = parseInt(excludeId);
                                var index = items.indexOf(excludeId);
                                if (index > -1) {
                                    items.splice(index, 1);
                                }
                            }

                            var count = $el.attr('products-count') || 4;

                            var searchQuery = items.slice(0, count).map(function (id) { return 'id:' + id; }).join(' OR ');

                            if (searchQuery) {

                                var sectionId = $el.attr('section-id');
                                var productsCount = $el.attr('products-count') || 4;

                                fetch(
                                    window.routes.stSearchUrl +
                                    '?q=' + searchQuery +
                                    '&resources[limit]=10' +
                                    '&resources[type]=product' +
                                    '&section_id=' + sectionId
                                ).then(function (res) {
                                    return res.text();
                                }).then(function (html) {

                                    var $html = $('<div>').html(html);
                                    var $target = $html.find('recently-productsviewed');

                                    if ($target.length && $target.html().trim() !== '') {

                                        $el.html($target.html());

                                        self.initSlick($('.recent-view-slick-carousel'));
                                        if (typeof AOS !== 'undefined') {
                                            AOS.init();
                                        }
                                    }

                                }).catch(function (err) {
                                    console.error('Error fetching recently viewed products:', err);
                                });
                            }
                        }

                    });

                }, { threshold: 0.5 });

                observer.observe($el[0]);
            }
        }

        getVariantFromOptions($form) {
            var productData = $form.data('product');
            if (!productData) return null;

            var variantInfo = $form.data('variant_json');
            if ( variantInfo ) {
                for (var i = 0; i < variantInfo.length; i++) {
                    $.extend(productData.variants[i], variantInfo[i]);
                }
            }

            var selectedOptions = [];

            $form.find('input.single-option-selector-radio:checked, select.single-option-selector-select').each(function () {
                selectedOptions.push($(this).val());
            });

            var foundVariant = null;

            $.each(productData.variants, function (i, variant) {
                var match = true;
                $.each(selectedOptions, function (index, option) {
                    if (variant.options[index] !== option) {
                        match = false;
                        return false;
                    }
                });

                if (match) {
                    foundVariant = variant;
                    return false;
                }
            });

            return foundVariant;
        }

        variantUpdatePrice(variant) {

            if (variant) {
                $('.product-single-price').html(
                    Shopify.formatMoney(variant.price, theme_opts.moneyFormat)
                );

                // Update and show the product's compare price if necessary
                if (variant.compare_at_price > variant.price) {
                    var sale_minus = variant.compare_at_price - variant.price;
                    var sale_per = sale_minus*100/variant.compare_at_price
                    var roundNumber = parseInt(sale_per);
                    $('.product-tag-sale-number').text(`${roundNumber}%`);
                    $('.product-tag-sale').removeClass('hide');

                    $('.product-single-price-compare').html(
                        Shopify.formatMoney(
                            variant.compare_at_price,
                            theme_opts.moneyFormat
                        )
                    ).removeClass('hide');
                } else {
                    $('.product-single-price-compare').addClass('hide');
                    $('.product-tag-sale').addClass('hide');
                }
                
            } else {
            
                $('.product-single-price-compare').addClass('hide');
            }
        }

        variantUpdateStock(variant, $form) {
            var sectionId = $form.data('section-id');
            var stockSetting = $('ProductSection-'+sectionId).data('stock');
            if (!stockSetting) return;

            var $stock = $('#ProductStock-' + sectionId),
                $hurrify = $('.js-hurrify'),
                $txtHurrify  = $('.js-hurrify .js-txt-hurrify');

            // If we don't track variant inventory, hide stock
            if (!variant || !variant.inventory_management) {
                $stock.addClass('hide');
                $hurrify.addClass('hide');
                return;
            }

            if (variant.inventory_quantity < 10 && variant.inventory_quantity > 0) {
                $stock.html(
                    theme_opts.strings.stockAvailable.replace(
                      '1',
                      variant.inventory_quantity
                    )
                ).removeClass('hide');
                $hurrify.removeClass('hide').find('.progress-bar').css('width',variant.inventory_quantity*10+'%');
                $txtHurrify.html(
                  theme_opts.strings.stringHurrify.replace(
                    'number',
                    variant.inventory_quantity
                  )
                );
                console.log(variant.inventory_quantity);
                return;
            }

            if (variant.inventory_quantity <= 0 && variant.incoming) {
                $stock.html(
                    theme_opts.strings.willNotShipUntil.replace(
                      '[date]',
                      variant.next_incoming_date
                    )
                ).removeClass('hide');
                $hurrify.addClass('hide');
                return;
            }

            // If there's more than 10 available, hide stock
            $stock.addClass('hide');
            $hurrify.addClass('hide');
        }

        variantUpdateIncomingInfo(variant, $form) {
            var sectionId = $form.data('section-id');
            var stockSetting = $('ProductSection-'+sectionId).data('stock');
            if (!stockSetting) return;

            var $stock = $('#ProductStock-' + sectionId);

            if (variant.incoming) {
                $stock.html(
                    theme_opts.strings.willBeInStockAfter.replace(
                      '[date]',
                      variant.next_incoming_date
                    )
                  ).removeClass('hide');
                return;
            }

            // If there is no stock incoming, hide stock
            $stock.addClass('hide');
        }

        variantUpdateAddToCartBtn(variant, $form) {
            var self = this;
            var sectionId = $form.data('section-id');
            var productData = $form.data('product');
            var cache = {
                $addToCart: $('#AddToCart-' + sectionId),
                $addToCartText: $('#AddToCartText-' + sectionId)
            };

            if (variant) {
           
                let optionName = productData.options;

                // Select a valid variant if available
                //theme_opts.noticeSoldout.init(variant);
                if (variant.available) {
                    // We have a valid product variant, so enable the submit button
                    cache.$addToCart.removeClass('btn--sold-out').prop('disabled', false);
                    cache.$addToCartText.html(theme_opts.strings.addToCart);
                    $('.shopify-payment-button', $form).show();
                    // Show how many items are left, if below 10
                    self.variantUpdateStock(variant, $form);
                    //update availability - available
                    $('.product-single__availability').find('span').text(theme_opts.strings.available);
                    $('.product__pickup-availabilities').show();
                    const a1 = optionName,
                        a2 = variant.options,
                        someFunction = (...values) => values.join(' '),
                        knownValue = ":",
                        output = a1.map((value1, i) => someFunction(value1, knownValue, a2[i]));
                    $('.pickup-availability-variant').text(output.join(", "));
                  
                } else {
                    // Variant is sold out, disable the submit button
                    cache.$addToCart.prop('disabled', true).addClass('btn--sold-out');
                    cache.$addToCartText.html(theme_opts.strings.soldOut);
                    $('.shopify-payment-button', $form).hide();
                    // Update when stock will be available
                    self.variantUpdateIncomingInfo(variant, $form);
                    //update availability - soldout
                    $('.product-single__availability').find('span').text(theme_opts.strings.soldOut);
                    $('.product__pickup-availabilities').hide();
                }
            } else {
                cache.$addToCart.prop('disabled', true).removeClass('btn--sold-out');
                cache.$addToCartText.html(theme_opts.strings.unavailable);
                //update availability - unavailable
                $('.product-single__availability').find('span').text(theme_opts.strings.unavailable);
                $('.shopify-payment-button', $form).hide();
                // Hide stock display
                self.variantUpdateStock(variant, $form);
                $('.product__pickup-availabilities').hide();
            }
        }

        variantUpdateSKU(variant) {
            if (variant) {
                $('.js-variant-sku').html(variant.sku);
            }
        }

        variantUpdateImages(variant, $form) {
            var sectionId = $form.data('section-id');
            if (variant && variant.featured_media) {
                var imageId = variant.featured_media.id;

                var media_style = $('#ProductSection-'+sectionId).data('media_style');
                var topMenuHeight = $('.site-header').outerHeight();

                if(media_style === 'media-list' || media_style === 'media-grid' || media_style === 'media-collage-1' || media_style === 'media-collage-2') {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $( '.apus-main-product-gallery div[data-image-id="' + imageId + '"]' ).offset().top-topMenuHeight
                    }, 600);
                } else {
                    $( '.apus-main-product-gallery-thumbs div[data-image-id="' + imageId + '"]' ).trigger( 'click' );
                }
            }
        }

        variantUpdateSwatchTitle(variant) {
            var options = variant.options;
            for (var e = 1; e <= options.length; e++) {
                var option = "option" + e;

                $(".js-swatch-display--" + e).text(variant[option])
            }
        }

        variantUpdateStickyCart (variant){
            var self = this;
            var $stickyPrice = $('#js-sticky-price'),
                $stickyTitle = $('#js-sticky-title'),
                $stickyImage = $('#js-sticky-img'),
                $stickyButton = $('#js-sticky-btn');
            if (variant) {
                //update title
                $stickyTitle.html(' - ' + variant.title);
                //update price
                $stickyPrice.html(Shopify.formatMoney(variant.price, theme_opts.moneyFormat));
                //update selectbox
                for (var i = 1; i <= 3; i++) {
                    var option = 'option' + i,
                        $selecBox = '#js-sticky-option-' + i;
                    if (variant[option] !== null){
                        var valueOption = variant[option];
                        $($selecBox).val(valueOption);
                    }
                }
                //update button cart
                if (variant.available) {
                    $stickyButton.prop('disabled', false).removeClass('btn--sold-out');
                    $stickyButton.html(theme_opts.strings.addToCart);
                } else {
                    $stickyButton.prop('disabled', true).addClass('btn--sold-out');
                    $stickyButton.html(theme_opts.strings.soldOut);
                }
                //update image
                if (variant.featured_image) {
                    $stickyImage.attr('src', self.getSizedImageUrl(variant.featured_image.src,'200x'));
                }
            } else {
                //update title
                $stickyTitle.html(' - ' + theme_opts.strings.unavailable);
                //update button cart
                $stickyButton.prop('disabled', true).removeClass('btn--sold-out');
                $stickyButton.html(theme_opts.strings.unavailable);
            }
        }

        getSizedImageUrl(src, size) {
            if (size === null) {
                return src;
            }

            if (size === 'master') {
                return src.replace(/http(s)?:/, '');
            }

            var match = src.match(
              /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
            );

            if (match !== null) {
                var prefix = src.split(match[0]);
                var suffix = match[0];

                var path = prefix[0] + '_' + size + suffix;
                return path.replace(/http(s)?:/, '');
            }

            return null;
        }

        generateCrosssell(){
            var handles = $('.js-crosssell-handles').data('handles') || '',
                arrayHandle = handles.split(',');

            for (var i = 0; i < arrayHandle.length; i++) {
                var productHandle = arrayHandle[i];
                Shopify.getProduct(productHandle,function(product){
                    var htmlCross = '',
                        htmlOption = '',
                        firstAvailableVariant = '',
                        variantCount = product.variants.length;

                    // generate select box and check first avaiable variant
                    for (var j = 0; j < variantCount; j++){
                        var variant = product.variants[j],
                            variantImage = variant.featured_image === null? product.featured_image : variant.featured_image.src,
                            disabled = variant.available ? '' : 'disabled';
                        htmlOption += '<option '+disabled+' data-id="'+variant.id+'" data-price="'+variant.price+'" data-image="'+variantImage+'">'+variant.title+'</option>';
                        if (firstAvailableVariant === '' && variant.available ){
                            firstAvailableVariant = variant
                        }
                    }

                    var productPrice = Shopify.formatMoney(firstAvailableVariant.price, theme_opts.moneyFormat),
                        productImage = firstAvailableVariant.featured_image === null ? product.featured_image : firstAvailableVariant.featured_image.src,
                        selectHide = variantCount === 1 ? 'hide' : '';

                    // generate HTML
                    htmlCross +='<div class="col cross-item '+product.handle+'">';
                    htmlCross +='   <a class="cross-item-image" href="'+product.url+'" title="'+product.title+'"><img src="'+productImage+'" /></a>';
                    htmlCross +='   <a class="link cross-item-image my-1 " href="'+product.url+'" title="'+product.title+'">'+ theme_opts.strings.addToCart +'</a>';
                    htmlCross +='   <a target="_blank" href="'+product.url+'" title="'+product.title+'" class="cross-item-title my-0">'+product.title+'</a>';
                    htmlCross +='   <span class="cross-item-money">'+productPrice+'</span>';
                    htmlCross +='   <select class="js-cross-select '+selectHide+'" data-image="'+productImage+'" data-price="'+firstAvailableVariant.price+'" data-item="'+firstAvailableVariant.id+'">'+htmlOption+'</select>';
                    htmlCross +='</div>';
                    $('.js-crosssell-handles').append(htmlCross);
                    //theme_opts.updateCurrencies();
                });
            }
        }

        showPopupCrosssell(lineItem){
            //generate lineitem;
            var htmlLineItem = '';
            htmlLineItem += '<span class="alert alert-success d-inline-block mb-3 w-100">'+ theme_opts.strings.addToCartSuccess +'</span>';
            htmlLineItem += '<div><img src="'+lineItem.image+'" alt="Added Product"></div>';
            htmlLineItem += '<h5 class="cross-item-title">'+lineItem.title+'</h5>';
            htmlLineItem += '<div class="mb-2 small">'+theme_opts.strings.cartQuantity+': '+lineItem.quantity+'</div>';
            $('.js-cross-added').hide().html(htmlLineItem).fadeIn();

            // show popup
            var $popupCrosssell = $('#js-crosssell-product');
            $popupCrosssell.modal('show');
        }

        productRecommendations(){
            var self = this;
            var $el = $('product-recommendations');

            if (!$el.length) return;

            var observer;

            var productId = $el.data('product-id');

            if (observer) {
                observer.unobserve($el[0]);
            }

            observer = new IntersectionObserver(function (entries, obs) {

                if (!entries[0].isIntersecting) return;

                obs.unobserve($el[0]);

                var url = $el.data('url');
                var sectionId = $el.data('section-id');

                fetch(url + '&product_id=' + productId + '&section_id=' + sectionId)
                .then(function (res) {
                    return res.text();
                }).then(function (html) {

                    var $html = $('<div>').html(html);
                    var $recommendations = $html.find('product-recommendations');

                    // render content
                    if ($recommendations.length && $.trim($recommendations.html()).length) {
                        $el.html($recommendations.html());
                    }

                    self.initSlick($('.product-recommendations-slick-carousel'));

                    // remove when has not slideshow
                    if (!$el.find('slideshow-component').length && $el.hasClass('complementary-products')) {
                        $el.remove();
                    }

                    // add class has item
                    if ($html.find('.grid__item').length) {
                        $el.addClass('product-recommendations--loaded');
                    }

                }).catch(function (err) {
                    console.error(err);
                });

            }, {
                rootMargin: '0px 0px 400px 0px'
            });

            observer.observe($el[0]);

        }

        createAlert(title, mess, type) {
            var aTitle = title || '',
                aMessage = mess || '',
                aClass = type || 'default';
            

            if ( aMessage ) {
                if ( aTitle ) {
                    aTitle = '<div class="heading-mess">'+aTitle+'</div>';
                }
                var $html = '<div id="apus-popup-message" class="animated fadeInRight '+ aClass +'">'+aTitle+'<div class="message-inner">'+ aMessage +'</div></div>';
                $('body').find('#apus-popup-message').remove();
                $('body').append($html).fadeIn(500);
                setTimeout(function() {
                    $('body').find('#apus-popup-message').removeClass('fadeInRight').addClass('delay-2s fadeOutRight');
                }, 2500);
            }
        }

        initMobileMenu() {

            // stick mobile
            var self = this;

            $('.js-navbar-toggler').on('click', function(){
                $('#js-nav-drawer-wrapper').addClass('active');
                $('.drawer-overlay').addClass('active');
            });

            $('.drawer-overlay, .drawer-action .close').on('click', function(){
                $('#js-nav-drawer-wrapper').removeClass('active');
                $('.drawer-overlay').removeClass('active');
            });
        }

        cookieSection() {
            var $cookieSection = $('.js-cookie-policy');
            
            const isAccepted = localStorage.getItem('localCookie') || '';

            if (!isAccepted) {
                $cookieSection.fadeIn('slow');
            }

            $('.js-btn-ok').on('click', () => {
                localStorage.setItem('localCookie', 'accept');
                $cookieSection.fadeOut('slow');
            });

            $('.js-btn-decline').on('click', () => {
                $cookieSection.fadeOut('slow');
            });

            if (Shopify.designMode) {
                document.addEventListener('shopify:section:load', () => {
                    $cookieSection.fadeOut('slow');
                });

                document.addEventListener('shopify:section:select', event => {
                    $(event.target).find($cookieSection).fadeIn('fast');
                });

                document.addEventListener('shopify:section:deselect', event => {
                    $(event.target).find($cookieSection).fadeOut('slow');
                });
            }
        }

        setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            var expires = "expires="+d.toUTCString();
            document.cookie = cname + "=" + cvalue + "; " + expires+";path=/";
        }

        getCookie(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for(var i=0; i<ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1);
                if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
            }
            return "";
        }
    }

    $.apusThemeCore = ApusThemeCore.prototype;
    
    $(document).ready(() => {
        const apusThemeCore = new ApusThemeCore();
        apusThemeCore.init();
        
    });

})(jQuery);